export const QUILL_DATA = {
  'ops': [
    {
      'insert': 'Header'
    },
    {
      'attributes': {
        'header': 1
      },
      'insert': '\n'
    },
    {
      'insert': 'SubHeader'
    },
    {
      'attributes': {
        'header': 2
      },
      'insert': '\n'
    },
    {
      'attributes': {
        'bold': true
      },
      'insert': 'This is some text for quill'
    },
    {
      'insert': '\n\nThis is some text for quill'
    },
    {
      'attributes': {
        'blockquote': true
      },
      'insert': '\n'
    },
    {
      'insert': '\n'
    },
    {
      'attributes': {
        'code': true
      },
      'insert': 'This is some text for quill'
    },
    {
      'insert': '\n'
    },
    {
      'attributes': {
        'italic': true
      },
      'insert': 'This is some text for quill'
    },
    {
      'insert': '\n\nThis is some text for quill\n\nThis is some text for quill\n'
    }
  ]
};
